import { render } from "./console.vue?vue&type=template&id=2b1e2c98&scoped=true"
import script from "./console.vue?vue&type=script&lang=js"
export * from "./console.vue?vue&type=script&lang=js"

import "./console.vue?vue&type=style&index=0&id=2b1e2c98&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1e2c98"]])

export default __exports__